import type { TruckConfiguration } from '#store/slices/configurationSlice'

export function deriveMarketLanguage(configuration: TruckConfiguration): string | undefined {
  const orderLanguage = configuration.apiConfiguration.orderLanguage
  if (!configuration.marketData || orderLanguage) {
    return orderLanguage
  }

  const marketLanguageId = configuration.apiConfiguration.language
  const marketData = configuration.marketData
  const marketLanguages = marketData.languages ?? []

  const languageByLanguageId = marketLanguages.find((language) => language.languageId === marketLanguageId)

  if (languageByLanguageId) {
    return languageByLanguageId.languageCode
  }

  return marketLanguages[0]?.languageCode
}
